export default __webpack_public_path__ + "static/media/mark-finn.40b78857.jpg";